/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

import { ActionsServiceRepositoryImpl } from '../impls/ActionsServiceRepositoryImpl';
import { IActionsServiceRepository } from '../interfaces/IActionsServiceRepository';
import { TActionList, TActionsParams, TServicesParams } from '../types';

export class ActionsService implements IActionsServiceRepository {
    private oActionsServiceRepository: IActionsServiceRepository;

    constructor(params: TServicesParams) {
        this.oActionsServiceRepository = new ActionsServiceRepositoryImpl(params);
    }

    async fetchOfferActions(actionsParams: TActionsParams): Promise<TActionList> {
        return this.oActionsServiceRepository.fetchOfferActions(actionsParams);
    }
}
